const prefix = 'fac';
const iconName = 'merge-extension';
const width = 515;
const height = 515;
const ligatures = [];
const unicode = null;
const svgPathData = 'M0 68C0 30.4446 30.4446 0 68 0H287C324.555 0 355 30.4446 355 68V287C355 324.555 324.555 355 287 355H68C30.4446 355 0 324.555 0 287V68Z M160 228C160 190.445 190.445 160 228 160H447C484.555 160 515 190.445 515 228V447C515 484.555 484.555 515 447 515H228C190.445 515 160 484.555 160 447V228Z';

export const definition = {
    prefix,
    iconName,
    icon: [
        width,
        height,
        ligatures,
        unicode,
        svgPathData,
    ],
};

export { definition as faMergeExtension };
